import React, { useContext, useEffect, useRef, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { Spin } from "antd";
import api from "../../services/Api";

/* Ilmoituksen luonti ilman rekisteröitymistä (Mika 3.11.2026): suoraan osoitteeseen
   /oma-sivu/ilmoitukset/uusi tuleva kirjautumaton kävijä (esim. mainoksesta) saa luonnostilin
   kuten "Jätä ilmoitus" -napista; rekisteröityminen vaaditaan vasta julkaisuvaiheessa. */
const UUSI_ILMOITUS = "/oma-sivu/ilmoitukset/uusi";

const LuonnosAloitus = () => {
    const { login } = useContext(AuthContext);
    const [virhe, setVirhe] = useState(false);
    const aloitettu = useRef(false);
    useEffect(() => {
        if (aloitettu.current) return;
        aloitettu.current = true;
        api.aloitaLuonnos("suora")
            .then((vastaus) => login(vastaus.token))
            .catch(() => setVirhe(true));
    }, [login]);
    if (virhe) {
        return <Navigate to="/kirjaudu" state={{ from: UUSI_ILMOITUS }} replace />;
    }
    return <Spin />;
};

const ProtectedRoute = ({ requiredRole }) => {
    const { isAuthenticated, user, setReferer, hasRole, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <Spin />;
    }

    if (!isAuthenticated && location.pathname === UUSI_ILMOITUS) {
        return <LuonnosAloitus />;
    }

    if (!isAuthenticated) {
        /* Kirjautumissivulle, ei etusivulle (Mika 30.9.2026): tekstiviestin linkki
           kauppakirjaan avautuu puhelimessa ilman kirjautumista, ja etusivulle tiputettu
           asiakas ei tiedä mitä tehdä. Login.js vie location.state.from -osoitteeseen
           heti kirjautumisen jälkeen. */
        setReferer(location.pathname + location.search);
        return <Navigate to="/kirjaudu" state={{ from: location.pathname + location.search }} replace />;
    }

    if (requiredRole && (!user || !hasRole(user.roles, requiredRole))) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
